(function () {
  angular.module('leanlaw').directive('llMatterFilter', MatterFilterDirective).controller('MatterFilterController', MatterFilterController);
  function MatterFilterDirective() {
    return {
      restrict: 'EA',
      require: 'ngModel',
      scope: {
        filterArchived: '=',
        filterSingleMatter: '=',
        filterDateRange: '=',
        filterDateDefault: '@',
        filterBillingType: '=',
        filterMatterTag: '=',
        filterAccount: '=',
        filterType: '@',
        filterLimitAccountSelection: '=',
        filterHideResponsible: '=',
        filterOrphans: '=',
        filterCustomFields: '=',
        disabled: '=',
        horizontal: '='
      },
      template: require('./views/matterFilter.html'),
      controller: 'MatterFilterController',
      controllerAs: 'vm',
      link: (scope, element, attrs, ngModel) => {
        scope.updateModel = function (filter) {
          ngModel.$setViewValue(angular.copy(filter));
        };
        ngModel.$viewChangeListeners.push(() => {
          scope.$eval(attrs.ngChange);
        });
      }
    };
  }
  MatterFilterController.$inject = ['$scope', 'matterFilterService', 'userService', 'lists', 'filterService', 'matterTagsService', '$http', 'leanLawAuth'];
  function MatterFilterController($scope, matterFilterService, userService, lists, filterService, matterTagsService, $http, leanLawAuth) {
    const vm = this;
    vm.filter = matterFilterService.state;
    vm.options = matterFilterService.options;
    vm.me = null;
    vm.filter.matterTag = undefined;
    vm.customFieldFilters = [];
    vm.domain = `${leanLawAuth.domain}/v1`;

    // Initialize custom fields if not already present
    if (!vm.filter.customFields) {
      vm.filter.customFields = {};
    }
    if (!vm.filter.customFieldMeta) {
      vm.filter.customFieldMeta = {};
    }
    activate();
    $scope.customFieldChanged = function () {
      $scope.updateModel(vm.filter);
    };
    $scope.clientChange = function () {
      vm.filter.matter = null;
    };
    $scope.matterChange = function () {
      if (vm.filter.matter && vm.filter.matter.client) {
        vm.filter.client = vm.options.clients.find(c => c.id === vm.filter.matter.client.id);
      }
    };
    $scope.scopeChange = function (prop) {
      vm.filter.scope = filterService.scopeFromFilter(vm.filter);
    };
    $scope.byClient = function (client) {
      return function (matter) {
        return !client || matter.client.id === client.id;
      };
    };
    /////////////////

    async function activate() {
      vm.options.billingTypes = lists.billingTypes;
      $scope.me = await userService.me();
      vm.me = $scope.me;
      await matterFilterService.loaded;
      if (vm.filter.scopeAccount && vm.filter.scopeAccount.id) {
        $scope.$emit('matterFilter:accountSelected', vm.filter.scopeAccount);
      }
      vm.options.matterTags = await matterTagsService.getMatterTags();

      // Load custom fields if feature flag is enabled AND filterCustomFields parameter is set
      if ($scope.filterCustomFields && $scope.me.features.customFieldFilters) {
        loadCustomFields();
      }
      $scope.$watch('vm.filter', filter => {
        if (filter.loading) return;
        $scope.updateModel(filter);
      }, true);
      $scope.scopeChange();
    }
    function loadCustomFields() {
      const path = `${vm.domain}/customfields`;
      $http.get(path).then(response => {
        const fields = response.data || [];
        // Filter for client and matter dropdown/enum fields that are active
        vm.customFieldFilters = fields.customFields.filter(f => (f.entity === 'matter' || f.entity === 'client') && f.type === 'enum' && f.active);

        // Build metadata map for quick lookups
        vm.filter.customFieldMeta = {};
        vm.customFieldFilters.forEach(field => {
          vm.filter.customFieldMeta[field.id] = {
            entity: field.entity,
            name: field.name
          };
        });
      }).catch(err => {
        console.error('Error loading custom fields:', err);
      });
    }
  }
})();